import { RadioButton, UIHeading2, UIHeading4, UIText2 } from '@cian/ui-kit';
import styles from './PriceDynamicsFilters.css';
import {
  EQueryParameters as EPeriod,
  EQueryParameters_1 as ERoomsCount,
} from 'shared/repositories/valuation-offer-history/v1/get-market-trand';
import { IGetAvailableFiltersForMarketTrandResponseSchema } from 'shared/repositories/valuation-offer-history/entities/market_trand/GetAvailableFiltersForMarketTrandResponseSchema';
import { ChangeEvent, FC } from 'react';
import { ConditionalWrapper } from '@cian/conditional-component';

export interface IFiltersProps {
  filters: IGetAvailableFiltersForMarketTrandResponseSchema;
  roomsCount: ERoomsCount;
  period: EPeriod;
  isDesktop: boolean;

  onRoomsCountChange(e: ChangeEvent): void;
  onPeriodChange(e: ChangeEvent): void;
}

export const PriceDynamicsFilters: FC<IFiltersProps> = ({
  filters,
  roomsCount,
  period,
  isDesktop,
  onRoomsCountChange,
  onPeriodChange,
}) => {
  const { oneRoom, twoRooms, threeRooms, fourPlusRooms, studio, all } = filters;

  return (
    <div className={styles['container']}>
      <div className={styles['title']}>
        <ConditionalWrapper if={isDesktop} ThenComponent={UIHeading2} ElseComponent={UIHeading4}>
          Динамика цен
        </ConditionalWrapper>
      </div>
      <div className={styles['layout']}>
        <div className={styles['rooms']} data-name="RoomsCountFilter">
          <div className={styles['subtitle']}>
            <UIText2>Количество комнат</UIText2>
          </div>
          <div className={styles['scrollable']}>
            <div className={styles['rooms-filter']}>
              {all && (
                <RadioButton
                  data-testid="priceDynamicAllRooms"
                  label="Все"
                  checked={ERoomsCount.All === roomsCount}
                  name="rooms"
                  value={ERoomsCount.All}
                  onChange={onRoomsCountChange}
                />
              )}

              {studio && (
                <RadioButton
                  checked={ERoomsCount.Studio === roomsCount}
                  label="Студия"
                  name="rooms"
                  value={ERoomsCount.Studio}
                  onChange={onRoomsCountChange}
                />
              )}

              {oneRoom && (
                <RadioButton
                  data-testid="priceDynamicOneRoom"
                  checked={ERoomsCount.OneRoom === roomsCount}
                  label="1"
                  name="rooms"
                  value={ERoomsCount.OneRoom}
                  onChange={onRoomsCountChange}
                />
              )}
              {twoRooms && (
                <RadioButton
                  checked={ERoomsCount.TwoRooms === roomsCount}
                  label="2"
                  name="rooms"
                  value={ERoomsCount.TwoRooms}
                  onChange={onRoomsCountChange}
                />
              )}
              {threeRooms && (
                <RadioButton
                  data-testid="priceDynamicThreeRooms"
                  checked={ERoomsCount.ThreeRooms === roomsCount}
                  label="3"
                  name="rooms"
                  value={ERoomsCount.ThreeRooms}
                  onChange={onRoomsCountChange}
                />
              )}
              {fourPlusRooms && (
                <RadioButton
                  checked={ERoomsCount.FourPlusRooms === roomsCount}
                  label="4+"
                  name="rooms"
                  value={ERoomsCount.FourPlusRooms}
                  onChange={onRoomsCountChange}
                />
              )}
            </div>
          </div>
        </div>
        <div className={styles['period']} data-name="PeriodFilter">
          <div className={styles['subtitle']}>
            <UIText2>Период</UIText2>
          </div>
          <div className={styles['scrollable']}>
            <div className={styles['period-filter']}>
              <RadioButton
                data-testid="priceDynamicPeriodAllTime"
                label="Всё время"
                name="period"
                onChange={onPeriodChange}
                value={EPeriod['All']}
                checked={period === EPeriod.All}
              />
              <RadioButton
                data-testid="priceDynamicPeriodYear"
                label="Год"
                name="period"
                onChange={onPeriodChange}
                value={EPeriod['OneYear']}
                checked={period === EPeriod.OneYear}
              />
              <RadioButton
                data-testid="priceDynamicPeriodHalfTime"
                label="Полгода"
                name="period"
                onChange={onPeriodChange}
                value={EPeriod['SixMonths']}
                checked={period === EPeriod.SixMonths}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
